"use client";

import { clsx } from "@trydig/ui";
import { useNewsletterSignup } from "~/lib/hooks/useNewsletterSignup";
import { textconfig } from "~/textconfig";
import styles from "./NewsletterForm.module.css";

const config = textconfig.footer.newsletter;

export const NewsletterForm = () => {
	const { inputName, handleSubmit, showInput, showLoading, inputRef, message, canSubmit } =
		useNewsletterSignup(config.errors);
	const hideInputClass = !showInput && styles.hide;

	return (
		<>
			{message?.type === "success" && (
				<p className={clsx(styles.message, styles.success)}>{message.label}</p>
			)}
			<form className={styles.newsletter} onSubmit={handleSubmit}>
				<div className={styles.newsletter_field}>
					<label className={"sr-only"}>{config.label}</label>

					<input
						name={inputName}
						ref={inputRef}
						type="email"
						className={clsx(styles.newsletter__input, hideInputClass)}
						placeholder={config.placeholder}
						required
					/>
				</div>

				<button
					type="submit"
					className={clsx(styles.submit__button, hideInputClass)}
					disabled={!canSubmit}
				>
					{showLoading ? config.buttonLoadingText : config.buttonText}
				</button>
			</form>
			{message?.type === "error" && (
				<p className={clsx(styles.message, styles.error)}>{message.label}</p>
			)}
		</>
	);
};
